import Client from "./client";

const baseUrl = `/api/1/transactions`;

function transaction() {
  return {
    deleteTransaction: ({ params }) => {
      const url = baseUrl + `/${params.id}`;
      return Client.delete(url);
    },
    getAllSuccessTransactions: ({ params }) => {
      const url = !!params.queryParams
        ? baseUrl +
          `/self/${params.pageSize}/${params.pageNumber}?${params.queryParams}`
        : baseUrl + `/self/${params.pageSize}/${params.pageNumber}`;
      return Client.get(url);
    },
    getAllFailTransactions: ({ params }) => {
      const url = !!params.queryParams
        ? baseUrl +
          `/fail/${params.pageSize}/${params.pageNumber}?${params.queryParams}`
        : baseUrl + `/fail/${params.pageSize}/${params.pageNumber}`;
      return Client.get(url);
    },
  };
}

export default transaction();
